// 关闭主题编辑器中仍处于打开状态的商品媒体弹窗，防止区块变动后留下失效内容。
function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

/**
 * 将 Base64 Data URL 转为 Blob，并保留 PNG、WebP 等真实 MIME 类型。
 * 关键兼容点：不再把所有图片都强制标记为 JPEG，避免 Firefox 上传后扩展名与内容不一致。
 */
function convertBase64ToBlob(base64) {
  if (typeof base64 !== 'string') throw new TypeError('Expected an image data URL.');
  var match = /^data:([^;,]+)?(?:;charset=[^;,]+)?;base64,([\s\S]+)$/i.exec(base64);
  if (!match) throw new Error('The image data URL is invalid.');
  var mimeType = match[1] || 'application/octet-stream';
  var binary = atob(match[2].replace(/\s/g, ''));
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mimeType });
}

// 主题编辑器选中幻灯片区块时，关闭商品弹窗、暂停轮播并滚动到被选中的幻灯片。
document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  // 等待编辑器完成区块选中布局，再把轮播定位到目标幻灯片。
  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

// 主题编辑器取消选择幻灯片区块后，按原自动播放设置恢复轮播。
document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

// 主题编辑器重新加载区块后，关闭旧弹窗并重新执行悬停缩放脚本。
document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    // 新建 script 节点替换旧节点，确保浏览器重新加载并执行该资源。
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

// 区块重新排序时关闭商品弹窗，避免弹窗引用移动前的 DOM。
document.addEventListener('shopify:section:reorder', () => hideProductModal());

// 区块被选中时关闭商品弹窗，避免遮挡主题编辑器的当前操作。
document.addEventListener('shopify:section:select', () => hideProductModal());

// 区块取消选择时关闭商品弹窗，清理编辑状态。
document.addEventListener('shopify:section:deselect', () => hideProductModal());

// 检查器启用时关闭商品弹窗，避免覆盖检查器的选中界面。
document.addEventListener('shopify:inspector:activate', () => hideProductModal());

// 检查器停用时关闭商品弹窗，确保退出检查器后页面状态一致。
document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());
